import React from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { Badge } from '@mui/material';
import { descriptionCellStyles } from '../components/report/ReportColumns';
import { labelColors, LabelType, ReportLineItemTypes } from '../components/report/report.type';

interface DragCellProps {
  params: GridRenderCellParams<any, any>;
  isDragging: boolean;
  dragRef: React.Ref<HTMLDivElement>;
}

const DragCell: React.FC<DragCellProps> = ({ params, isDragging, dragRef }) => {
  const shouldShowBadge = params.row.id !== 'total' && params.row.id !== 'general conditions total';
  const noteContent = params.row.note?.content;
  const isCompPricingRow = params.row.type === ReportLineItemTypes.CompPricing;

  return (
    <div
      ref={dragRef}
      style={{
        ...descriptionCellStyles.container,
        opacity: isDragging ? 0.5 : 1,
        cursor: 'move',
      }}
    >
      <div style={descriptionCellStyles.row}>
        <span
          style={{
            ...descriptionCellStyles.description,
            lineHeight: noteContent ? '32px' : undefined,
            // Allow wrapping only for CompPricing rows
            whiteSpace: isCompPricingRow ? 'normal' : 'nowrap',
            wordBreak: isCompPricingRow ? 'break-word' : undefined,
            overflowWrap: isCompPricingRow ? 'anywhere' : undefined,
          }}
        >
          {params.row.lineItem?.description || '--'}
        </span>
        {shouldShowBadge && params.row.label && (
          <div style={descriptionCellStyles.badgeContainer}>
            <Badge
              badgeContent={params.row.label}
              color='primary'
              sx={{
                '& .MuiBadge-root': { margin: 0 },
                '& .MuiBadge-badge': {
                  backgroundColor: labelColors[params.row.label as LabelType] || 'gray',
                  position: 'static',
                  transform: 'none',
                },
              }}
            />
          </div>
        )}
      </div>
      {noteContent && (
        <div style={descriptionCellStyles.noteContainer} title={noteContent}>
          {noteContent}
        </div>
      )}
    </div>
  );
};

export default React.memo(DragCell);
